<label for="{{name}}" class="flex items-center cursor-pointer select-none w-full" [formGroup]="formGroup"
>
  <div class="relative">
    <input *ngIf="!multiChoices" type="checkbox" id="{{name}}" class="sr-only"
           [formControlName]="name" [attr.aria-label]="label" [tabIndex]="tabIndex" appAutofocus [autofocus]="autoFocus" (change)="onChange.emit()"/>

    <input *ngIf="multiChoices" type="radio" class="sr-only" [value]="choiceValue"
           [formControlName]="name" [attr.aria-label]="label" [tabIndex]="tabIndex" appAutofocus [autofocus]="autoFocus" (click)="onChange.emit()"/>

    <div class="flex items-center justify-center w-8 h-8 mr-4 border-2 border-stroke border-theme-black rounded box bg-white" (click)="onChangeOption.emit(choiceValue)">
         <span [class.opacity-0]="(!multiValues && !multiChoices && !formGroup.controls[name].value)
                  || (!multiValues && multiChoices && choiceValue != formGroup.controls[name].value)
                  || (multiValues && !formGroup.controls[name].value.includes(choiceValue))">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" fill="currentColor" class="size-7">
              <path fill-rule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z" clip-rule="evenodd" />
            </svg>
         </span>
    </div>
  </div>
  <span class="h-8 " (click)="onChangeOption.emit(choiceValue)" [innerHTML]="label"
        [ngClass]="{'mt-2 text-base': big, '-mt-1 xs-offer:-mt-0 text-sm': !big}"
        [class.text-white]="!black" [class.text-theme-black]="black"></span>
</label>
